import { LiveSwitchAction } from "../../../LiveSwitch/liveSwitchActions";
import * as LSTypes from "../../../LiveSwitch/liveSwitchActionTypes";
import { SessionPhoto as Photo } from "../../../Shared/GeneratedTypes";
import * as types from "../actions/actionTypes";
import { CurrentMentorsActions } from "../actions/currentClientActions";
import initialState from "./initialState";

export default function photosReducer(
    state = initialState.photos,
    action: CurrentMentorsActions | LiveSwitchAction
): Photo[] {
    switch (action.type) {
        case types.LOAD_CURRENT_MENTORS_BY_ID_SUCCESS:
            //initial load of photos collection can be more destructive since its a full set replacement
            return action.session.sessionInfo.photos;
        case LSTypes.PHOTO_REQUEST_RECEIVED:
        case types.REQUEST_PHOTO: {
            return [
                ...state,
                {
                    id: action.photoId,
                    addedUTC: new Date(),
                    tags: [],
                    url: "",
                },
            ];
        }

        case LSTypes.PHOTO_REMOVED: {
            return state.filter((p) => p.id !== action.photoId);
        }

        case LSTypes.COMMAND_SEND_PHOTO_URL: {
            const id = action.id;
            return state.map((p) => (p.id === id ? { ...p, url: action.url, thumbnailUrl: action.thumbnailUrl } : p));
        }
        case LSTypes.VIDEO_FRAME_TAG_PHOTO_URL_RECEIVED: {
            let photo = action.photo;
            return [
                ...state,
                {
                    tags: [],
                    id: photo.id,
                    url: photo.url,
                    thumbnailUrl: photo.thumbnailUrl,
                    addedUTC: photo.addedUTC
                } as Photo
            ];
        }
        default:
            return state;
    }
}
